import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconDirectionsBus = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconDirectionsBus",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M320-200v20q0 25-17 43t-43 17-42-17-18-43v-62q-18-20-29-44t-11-54v-380q0-83 77-121t243-39q172 0 246 37t74 123v380q0 29-11 54t-29 44v62q0 25-17 43t-43 17-42-17-18-43v-20zm-80-360h480v-120H240zm100 240q25 0 43-17t17-43-17-42-43-18-42 18-18 42 18 43 42 17m280 0q25 0 43-17t17-43-17-42-43-18-42 18-18 42 18 43 42 17"
  })
}));